<build-section
  title="{{group.name}}"
  [disabled]="disabled">
  <div class="mt-sm-max-3 position-relative">
    <ui-extra-products-radio *ngIf="group?.maxSelections === 1"
                             [items]="selectItems"
                             [showPictures]="group.hasPicture"
                             [selectedItem]="selectedProducts ? selectedProducts[0] : []"
                             (onImageSelect)="imageSelect($event)"
                             (modelChange)="onProductsSelect($event)"></ui-extra-products-radio>

    <ui-extra-products-checkbox *ngIf="group?.maxSelections !== 1"
                                [items]="selectItems"
                                [showPictures]="group.hasPicture"
                                [maxSelections]="group?.maxSelections"
                                [selectedItems]="selectedProducts"
                                (onImageSelect)="imageSelect($event)"
                                (modelChange)="onProductsSelect($event)"></ui-extra-products-checkbox>
    <ui-extra-product-popup-picture
      *ngIf="pic.show"
      (onPicClick)="pic.show=false"
      [pic]="pic"></ui-extra-product-popup-picture>

  </div>
  <div class="help-text">
    {{group.helpText}}
  </div>
</build-section>
